import {Typography} from 'antd'; 
const { Title } = Typography;


const StatsStrip = () => {
    return (
        <div className={'flex w-full justify-center strip-wapper flex-wrap' }>
            <div className={'flex w-full justify-around strip-innder-wapper flex-wrap' }>
                <div className={'strip-item flex flex-col'}>
                    <Title  style={{margin:0}} className={'m-0   text-grey-1 text-center pt-4 mb-1'} level={2}>2501+</Title>
                    <Title  style={{margin:0}} className={'m-0   text-grey text-center pb-4'} level={5}>Registrations</Title>
                </div>
                <div className={'strip-item flex flex-col'}>
                    <Title  style={{margin:0}} className={'m-0   text-grey-1 text-center pt-4 mb-1'} level={2}>750+</Title>
                    <Title  style={{margin:0}} className={'m-0   text-grey text-center pb-4'} level={5}>Cities Supported</Title>
                </div>
                <div className={'strip-item flex flex-col'}>
                    <Title  style={{margin:0}} className={'m-0  text-grey-1  text-center pt-4 mb-1'} level={2}>12001+</Title>
                    <Title  style={{margin:0}} className={'m-0   text-grey text-center pb-4'} level={5}>Notifications Sent</Title>
                </div>
            </div>
        </div>
    )
}

export default StatsStrip